var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosofticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.797852 14.578V6.28848L11.3861 4.20427V14.4359L0.797852 14.578ZM30.7979 0.367432V14.1832L13.1508 14.4201V3.85691L30.7979 0.367432ZM0.797852 16.1569L11.3861 16.299V27.0516L0.797852 25.2359V16.1569ZM30.7979 16.5516V30.3674L13.1508 27.3516V16.3148L30.7979 16.5516Z",
    fill: "#04ADF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosofticon);
export default __webpack_public_path__ + "static/media/microsoft.icon.dd80f5a0d15dd42462e9ab7e6666ea36.svg";
export { ForwardRef as ReactComponent };